import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=96ed70e8&scoped=true&"
import script from "./Tabs.vue?vue&type=script&lang=js&"
export * from "./Tabs.vue?vue&type=script&lang=js&"
import style0 from "./Tabs.vue?vue&type=style&index=0&id=96ed70e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ed70e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('96ed70e8', component.options)
    } else {
      api.reload('96ed70e8', component.options)
    }
    module.hot.accept("./Tabs.vue?vue&type=template&id=96ed70e8&scoped=true&", function () {
      api.rerender('96ed70e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/EquiposEnTerreno/components/Tabs.vue"
export default component.exports